export function integrateIdToURL(str: string, replacement: string | number): string {
  return str.replace(/\{id\}/g, replacement.toString());
}
export const toYearMonthDayString = (date?: any) => {
  const dateObj = date ? new Date(date) : new Date();
  const month = dateObj.getUTCMonth() + 1;
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();
  return `${year}-${month}-${day}`;
};
